export default "__VITE_ASSET__70828662__"